import { MenuItem } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UserField } from '../../../../constants/user-labels';
import { UserModel } from '../../../../models';
import { DefaultModelField } from '../../../../models/default-model';
import { selectUser } from '../../../../store/reducers';
import { useGetFilterUsers } from '../../../../utils/hooks';
import { GtSelect } from '../../../gt-select/GtSelect';

interface UserFilterProps {
  className: string;
  filtersValue: string;
  onFiltersChange?: (user: string) => void;
}

export function UserFilter({
  filtersValue,
  className,
  onFiltersChange,
}: UserFilterProps) {
  const user = useSelector(selectUser);

  const data = useGetFilterUsers();

  const options = useMemo(() => {
    if (!data) {
      return [];
    }

    const users = data.map(
      (item): Partial<UserModel> =>
        user && user[DefaultModelField.Id] === item[DefaultModelField.Id]
          ? {
              ...item,
              name: `(Me) ${item.name}`,
            }
          : item,
    );

    return [
      {
        [DefaultModelField.Id]: '-',
        name: 'All users',
      },
      ...users,
    ];
  }, [data]);

  if (!data) {
    return null;
  }

  const onUserFilterChanged = (event) => {
    const { value } = event.target;

    onFiltersChange(value);
  };

  return (
    <GtSelect
      fullWidth
      className={className}
      variant="outlined"
      size="small"
      disabled={false}
      value={filtersValue || '-'}
      onChange={onUserFilterChanged}
      name={UserField.Role}
      label="Filter by user"
      inputProps={{
        name: 'userFilter',
        id: 'userFilter',
      }}
    >
      {(options || []).map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </GtSelect>
  );
}
